import SmoothScroll from 'smoothscroll-polyfill';
import { $, $$, offset } from '../helper/utils';

SmoothScroll.polyfill();

export const scrollTo = function (e) {
    let target = '';
    let type = 'target';
    const scrollParent = this.getAttribute('data-scroll-parent');
    const scrollTarget = this.getAttribute('data-scroll-target');

    if (this.hasAttribute('href')) {
        e.preventDefault();
        target = this.getAttribute('href');
    }

    if (scrollParent !== null) {
        target = scrollParent;
        type = 'parent';
    }

    if (scrollTarget !== null) {
        target = scrollTarget;
    }

    const el = $(target);

    if (el === null) {
        console.warn('No target to scroll to');
        return;
    }

    const { top } = offset(el);
    switch (type) {
        case 'parent':
            window.scroll({ top: top + el.getBoundingClientRect().height, left: 0, behavior: 'smooth' });
            break;
        default:
            window.scroll({ top: top - 50, left: 0, behavior: 'smooth' });
            break;
    }

    return;
};

export const init = () => {
    const scrollElements = $$('.scrollto');
    for (let i = 0; i < scrollElements.length; i++) {
        const el = scrollElements[i];

        if (el.hasAttribute('href')) {
            el.addEventListener('click', scrollTo);
        } else {
            el.addEventListener('click', scrollTo, { passive: true });
        }
    }
};